import { Link } from "react-router-dom";
import { LegalLayout } from "@/components/SiteFooter";
import { Seo } from "@/components/Seo";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Use" updated="October 11, 2026">
      <Seo title="Terms of Use" description="The terms for using PillarWealth.io, the PillarWealth retirement tracker for TSP, FERS and IRA planning." path="/terms" />
      <p>These terms apply to your use of PillarWealth.io, operated by Atkins Media, LLC ("we", "us"). By creating an account or using the site you agree to them.</p>
      <h2>Educational estimates only</h2>
      <p>Projections, pension and Social Security estimates, retirement dates, checklists and articles are for education. They are not financial, investment, tax or legal advice. Confirm benefits and deadlines with your agency HR, OPM, the Federal Retirement Thrift Investment Board and the Social Security Administration before acting.</p>
      <h2>Your account</h2>
      <ul>
        <li>Keep your sign-in details private and tell us if you think your account was accessed without permission.</li>
        <li>You are responsible for the accuracy of the information you enter or import.</li>
        <li>You can stop using the service at any time and ask us to delete your account.</li>
      </ul>
      <h2>Acceptable use</h2>
      <p>Do not misuse the service: no attempts to access other users' data, overload or disrupt the site, scrape it at scale, or use it for anything unlawful.</p>
      <h2>Third-party data and services</h2>
      <p>Fund prices, market data and news come from public third-party sources and may be delayed or contain errors. Account linking is provided through Plaid under its own terms. Ads are served by Google AdSense as described in our <Link to="/cookies">Cookie Policy</Link> and <Link to="/privacy">Privacy Policy</Link>.</p>
      <h2>Emails</h2>
      <p>Weekly recap and milestone alert emails are optional. Every email has an unsubscribe link, and you can change your choices in the app.</p>
      <h2>No warranty</h2>
      <p>The service is provided "as is" without warranties of any kind. To the extent the law allows, we are not liable for losses arising from decisions made using the site's estimates or content.</p>
      <h2>Changes</h2>
      <p>We may update these terms. The date above shows the latest version, and continued use means you accept the update.</p>
      <h2>Contact</h2>
      <p>Questions: <a href="mailto:support@atkinsmedia.io">support@atkinsmedia.io</a>.</p>
    </LegalLayout>
  );
}
